/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Csv_To_Json_Deep_P3Inputs */

const en_csv_to_json_deep_p3 = /** @type {(inputs: Csv_To_Json_Deep_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converting types is far safer once you know what a column means, which is knowledge that lives in your code rather than in the file. Take the string output and map it deliberately, coercing the columns you know are numeric and leaving identifiers alone. It is a few lines of work and it never eats a leading zero.`)
};

const ko_csv_to_json_deep_p3 = /** @type {(inputs: Csv_To_Json_Deep_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`타입 변환은 열이 무엇을 뜻하는지 알고 나면 훨씬 안전해지는데, 그 지식은 파일이 아니라 코드에 있습니다. 문자열 출력을 받아 의도적으로 매핑하세요. 숫자라고 아는 열은 변환하고 식별자는 그대로 두는 것입니다. 몇 줄이면 되고, 앞의 0을 먹어치우는 일이 결코 없습니다.`)
};

const ja_csv_to_json_deep_p3 = /** @type {(inputs: Csv_To_Json_Deep_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`型変換は列が何を意味するか分かってからのほうがはるかに安全で、その知識はファイルではなくコードにあります。文字列の出力を受け取り、意図的にマッピングしてください。数値だと分かっている列を変換し、識別子はそのままにします。数行の作業で、先頭のゼロを食べてしまうことは決してありません。`)
};

/**
* | output |
* | --- |
* | "Converting types is far safer once you know what a column means, which is knowledge that lives in your code rather than in the file. Take the string output a..." |
*
* @param {Csv_To_Json_Deep_P3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const csv_to_json_deep_p3 = /** @type {((inputs?: Csv_To_Json_Deep_P3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Csv_To_Json_Deep_P3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_csv_to_json_deep_p3(inputs)
	if (locale === "ko") return ko_csv_to_json_deep_p3(inputs)
	return ja_csv_to_json_deep_p3(inputs)
});